import { render, staticRenderFns } from "./paymentHead.vue?vue&type=template&id=81ec9e50&scoped=true&"
import script from "./paymentHead.vue?vue&type=script&lang=js&"
export * from "./paymentHead.vue?vue&type=script&lang=js&"
import style0 from "./paymentHead.vue?vue&type=style&index=0&id=81ec9e50&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ec9e50",
  null
  
)

export default component.exports